import React from "react";
import { useForm } from "react-hook-form";

interface Props {
  defaultValues?: { [x: string]: any };
  children: any;
  onSubmit: any;
}

const Form: React.FC<Props> = ({
  defaultValues,
  children,
  onSubmit
}: Props) => {
  const methods = useForm({ defaultValues });
  const { handleSubmit } = methods;

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
      {React.Children.map(children, child => {
        return child.props.name
          ? React.createElement(child.type, {
              ...{
                ...child.props,
                register: methods.register,
                key: child.props.name
              }
            })
          : child;
      })}
    </form>
  );
};

export default Form;
